var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var EventEmitter = require('events').EventEmitter;

var hdkey = require('ethereumjs-wallet/hdkey');

var bip39 = require('bip39');

var ethUtil = require('ethereumjs-util');

var sigUtil = require('eth-sig-util'); // Options:


var hdPathString = "m/44'/60'/0'/0";
var type = 'HD Key Tree';

var HdKeyring =
/*#__PURE__*/
function (_EventEmitter) {
  "use strict";

  _inherits(HdKeyring, _EventEmitter);

  /* PUBLIC METHODS */
  function HdKeyring() {
    var _this;

    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, HdKeyring);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HdKeyring).call(this));
    _this.type = type;

    _this.deserialize(opts);

    return _this;
  }

  _createClass(HdKeyring, [{
    key: "serialize",
    value: function serialize() {
      return Promise.resolve({
        mnemonic: this.mnemonic,
        numberOfAccounts: this.wallets.length,
        hdPath: this.hdPath
      });
    }
  }, {
    key: "deserialize",
    value: function deserialize() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.opts = opts || {};
      this.wallets = [];
      this.mnemonic = null;
      this.root = null;
      this.hdPath = opts.hdPath || hdPathString;

      if (opts.mnemonic) {
        this._initFromMnemonic(opts.mnemonic);
      }

      if (opts.numberOfAccounts) {
        return this.addAccounts(opts.numberOfAccounts);
      }

      return Promise.resolve([]);
    }
  }, {
    key: "addAccounts",
    value: function addAccounts() {
      var numberOfAccounts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      if (!this.root) {
        this._initFromMnemonic(bip39.generateMnemonic());
      }

      var oldLen = this.wallets.length;
      var newWallets = [];

      for (var i = oldLen; i < numberOfAccounts + oldLen; i++) {
        var child = this.root.deriveChild(i);
        var wallet = child.getWallet();
        newWallets.push(wallet);
        this.wallets.push(wallet);
      }

      var hexWallets = newWallets.map(function (w) {
        return sigUtil.normalize(w.getAddress().toString('hex'));
      });
      return Promise.resolve(hexWallets);
    }
  }, {
    key: "getAccounts",
    value: function getAccounts() {
      return Promise.resolve(this.wallets.map(function (w) {
        return sigUtil.normalize(w.getAddress().toString('hex'));
      }));
    } // tx is an instance of the ethereumjs-transaction class.

  }, {
    key: "signTransaction",
    value: function signTransaction(address, tx) {
      var wallet = this._getWalletForAccount(address);

      var privKey = wallet.getPrivateKey();
      tx.sign(privKey);
      return Promise.resolve(tx);
    } // For eth_sign, we need to sign transactions:
    // hd

  }, {
    key: "signMessage",
    value: function signMessage(withAccount, data) {
      var wallet = this._getWalletForAccount(withAccount);

      var message = ethUtil.stripHexPrefix(data);
      var privKey = wallet.getPrivateKey();
      var msgSig = ethUtil.ecsign(new Buffer(message, 'hex'), privKey);
      var rawMsgSig = ethUtil.bufferToHex(sigUtil.concatSig(msgSig.v, msgSig.r, msgSig.s));
      return Promise.resolve(rawMsgSig);
    } // For personal_sign, we need to prefix the message:

  }, {
    key: "signPersonalMessage",
    value: function signPersonalMessage(withAccount, msgHex) {
      var wallet = this._getWalletForAccount(withAccount);

      var privKey = ethUtil.stripHexPrefix(wallet.getPrivateKey());
      var privKeyBuffer = new Buffer(privKey, 'hex');
      var sig = sigUtil.personalSign(privKeyBuffer, {
        data: msgHex
      });
      return Promise.resolve(sig);
    } // personal_signTypedData, signs data along with the schema

  }, {
    key: "signTypedData",
    value: function signTypedData(withAccount, typedData) {
      var wallet = this._getWalletForAccount(withAccount);

      var privKey = ethUtil.toBuffer(wallet.getPrivateKey());
      var signature = sigUtil.signTypedData(privKey, {
        data: typedData
      });
      return Promise.resolve(signature);
    } // For eth_sign, we need to sign transactions:

  }, {
    key: "newGethSignMessage",
    value: function newGethSignMessage(withAccount, msgHex) {
      var wallet = this._getWalletForAccount(withAccount);

      var privKey = wallet.getPrivateKey();
      var msgBuffer = ethUtil.toBuffer(msgHex);
      var msgHash = ethUtil.hashPersonalMessage(msgBuffer);
      var msgSig = ethUtil.ecsign(msgHash, privKey);
      var rawMsgSig = ethUtil.bufferToHex(sigUtil.concatSig(msgSig.v, msgSig.r, msgSig.s));
      return Promise.resolve(rawMsgSig);
    }
  }, {
    key: "exportAccount",
    value: function exportAccount(address) {
      var wallet = this._getWalletForAccount(address);

      return Promise.resolve(wallet.getPrivateKey().toString('hex'));
    }
    /* PRIVATE METHODS */

  }, {
    key: "_initFromMnemonic",
    value: function _initFromMnemonic(mnemonic) {
      this.mnemonic = mnemonic;
      var seed = bip39.mnemonicToSeed(mnemonic);
      this.hdWallet = hdkey.fromMasterSeed(seed);
      this.root = this.hdWallet.derivePath(this.hdPath);
    }
  }, {
    key: "_getWalletForAccount",
    value: function _getWalletForAccount(account) {
      var targetAddress = sigUtil.normalize(account);
      return this.wallets.find(function (w) {
        var address = sigUtil.normalize(w.getAddress().toString('hex'));
        return address === targetAddress || sigUtil.normalize(address) === targetAddress;
      });
    }
  }]);

  return HdKeyring;
}(EventEmitter);

HdKeyring.type = type;
module.exports = HdKeyring;